// extracted by extract-css-chunks-webpack-plugin
module.exports = {"type":"_28z5Fp"};